import * as React from "react";
const PlusIcon = (props) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.5873 3.99219V14.0105M3.57812 9.00136H13.5965"
      stroke={props?.color ?? "#0F172A"}
      strokeWidth={1.43406}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default PlusIcon;
